<template>
  <div class="flow-file-list ds_uploadFile ds-upload">
    <table class="layui-table fileContainer upload-table" width="100%">
      <tbody>
        <tr v-for="(file, i) in Attachments" :key="i" class="list-item">
          <td class="textLeft">
            <div class="fileName" @click="downLoadFile(file)">
              <i class="icon" :class="file.suffix"></i>
              <span>{{ file.originalFileName }}</span>
            </div>
          </td>
          <td v-if="!isVertical" class="blank fontpostion" width="100">
            {{ computeFileSize(file.size) }}
          </td>
          <td v-if="!isVertical" class="operate fontpostion" width="100">
            <span
              class="previewBtn iconfont"
              title="预览"
              @click="preview(file)"
            >&#xeb8d;</span
            >
            <span class="downLoad iconfont downLoadBtn">
              <i
                class="iconfont"
                title="下载"
                @click="downLoadFile(file)"
              >&#xec22;</i
              >
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "DsfFlowFileList",
  props: {
    Attachments: {
      type: Array,
      default() {
        return [];
      },
    },
    isVertical: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    preview(file) {
      const preUrl = dsf.config.setting_public_file_host;
      const relativePath = file.relativePath;
      let url = `preview/file?url=${preUrl}${relativePath}`;
      this.$openWindow({
        url: dsf.url.getWebPath(url),
      });
    },
    downLoadFile(row) {
      var url = dsf.url.getWebPath("file/download");
      $(
        `<form action="${url}" method="get">
          <input type="text" name="files" value="${row.id}"/>
          <input type="text" name="zipName" value="${row.fileName || ""}"/>
        </form>`
      )
        .appendTo("body")
        .submit()
        .remove();
    },
    computeFileSize(fileSize) {
      let filesizeUnit = "";
      if (parseInt(fileSize) > 1050000) {
        filesizeUnit = (fileSize / Math.pow(1024, 2)).toFixed(2) + "M";
      } else {
        filesizeUnit = (fileSize / Math.pow(1024, 1)).toFixed(2) + "K";
      }
      return filesizeUnit;
    },
  },
};
</script>
